import React from "react";
import fakeData from "../../fakeData";

const Inventory = () => {
  const handleAddProduct = () => {
    fetch("https://dry-mountain-11982.herokuapp.com/addProducts", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(fakeData),
    }).then((res) => {
        if(res) {
            alert("all data inserted successfully")
        }
    });
  };

  return (
    <div>
      <h1>this is inventory</h1>
      <button onClick={handleAddProduct}>add product</button>
    </div>
  );
};

export default Inventory;
